export const ex30ccModelData = {
  model: "EX30CC",
  points: [
    {
      categoryNodeId: "efe38c8d40e92814c0a8018858356e3b",
      title: "Vehicle propulsion",
      x: 270,
      y: 150,
      hoverImg: "EX30CC_Vehicle_Propulsion.webm",
      type: "video",
    },
    {
      categoryNodeId: "a2d00331dc33a213c0a8018879a6678f",
      title: "Thermal management",
      x: 240,
      y: 220,
      hoverImg: "EX30CC_Thermal_management.png",
      type: "image",
    },
    {
      categoryNodeId: "7ae9de4e40ea04e8c0a801885823b0b4",
      title: "Electrical systems",
      x: 520,
      y: 150,
      hoverImg: "EX30CC_Electrical_System.webm",
      type: "video",
    },
    {
      categoryNodeId: "0108cc1be9a8c52fc0a8018841a6649a",
      title: "Infotainment, connectivity and multimedia",
      x: 420,
      y: 120,
      hoverImg: "EX30CC_Infotainment.png",
      type: "image",
    },
    {
      categoryNodeId: "76c84a2ea921bec7c0a801884a06e19c",
      title: "Brake system",
      x: 470,
      y: 300,
      hoverImg: "EX30CC_Brake_system.png",
      type: "image",
    },
    {
      categoryNodeId: "e2c8f4b5dc3493a2c0a801883b4e184c",
      title: "Safety systems",
      x: 680,
      y: 30,
      hoverImg: "EX30CC_Safety_system.png",
      type: "image",
    },
    {
      categoryNodeId: "5041dfbf40ead6eec0a80188691dcef7",
      title: "Wheel suspension",
      x: 480,
      y: 200,
      hoverImg: "EX30CC_Wheel_suspension.png",
      type: "image",
    },
    {
      categoryNodeId: "dbee9edaa96a1c3fc0a80188587f2495",
      title: "Steering",
      x: 310,
      y: 280,
      hoverImg: "EX30CC_Steering.png",
      type: "image",
    },
    {
      categoryNodeId: "7a635be8a96a8fbac0a80188048a9e9b",
      title: "Wheels and rims",
      x: 740,
      y: 200,
      hoverImg: "EX30CC_Wheel_and_rims.png",
      type: "image",
    },
    {
      categoryNodeId: "ea00526b40eb5640c0a801885f49fb4b",
      title: "Body",
      x: 700,
      y: 240,
      hoverImg: "EX30CC_Body.png",
      type: "image",
    },
    {
      categoryNodeId: "c39683ece1a70422c0a801886764d6e2",
      title: "Exterior",
      x: 680,
      y: 120,
      hoverImg: "EX30CC_Exterior.png",
      type: "image",
    },
    {
      categoryNodeId: "b40d64887d3296d4c0a801883be7d324",
      title: "Interior",
      x: 620,
      y: 70,
      hoverImg: "EX30CC_Interior.png",
      type: "image",
    },
  ],
};